import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const blogs = $$('.blogs');

if (blogs.length) {
  blogs.forEach(blog => {
    const slider = new Swiperslider($('.blogs__item-wrapper', blog), {
      container: blog,
      sliderOptions: {
        spaceBetween: 30,
      },
    });
    slider.init();
  });
}
